module.exports = __webpack_public_path__ + "img/adTemplate.090ab03d.svg";